import getLocalized from './get-localized';

export default function trimMetaItems(items, length = 2) {
  return (items || [])
    .slice(0, length)
    .map(item => getLocalized(item, item.UA))
    .join(', ');
}
